export default __webpack_public_path__ + "static/3-eb0686cb51e271b6cd49ba20878e3bb5.jpeg";